// extracted by mini-css-extract-plugin
export default {"buttonBlue":"MainButton_buttonBlue__HaCI7","button":"MainButton_button__NJCJZ"};